(() => {
  'use strict';

  const SELECTOR_TIMER = '.nextdev--hero-banners--image-content-main-timer';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  const now   = () => Date.now();
  const pad2  = (n) => String(n).padStart(2, '0');

  // Изчислява секундите до края на деня (00:00 утре)
  function getSecondsUntilEndOfDay() {
    const n = new Date();
    const endOfDay = new Date(n);
    endOfDay.setHours(24, 0, 0, 0);
    return Math.floor((endOfDay - n) / 1000);
  }

  function computeHMS(seconds) {
    const s = Math.max(0, seconds);
    const hours   = Math.floor(s / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const secs    = s % 60;
    return { hours, minutes, seconds: secs };
  }

  function animateSeconds(el, value) {
    if (el.textContent === value) return;
    el.textContent = value;
    el.classList.remove('animate-change');
    void el.offsetWidth;
    el.classList.add('animate-change');
  }

  function isDesignMode() {
    return typeof Shopify !== 'undefined' && Shopify.designMode;
  }

  function initTimer(timerRoot) {
    if (!timerRoot || timerRoot.dataset.heroTimerInit === '1') return;
    timerRoot.dataset.heroTimerInit = '1';

    const els = {
      hours:   timerRoot.querySelector('.nextdev--hero-banners--image-content-main-timer-block-hours'),
      minutes: timerRoot.querySelector('.nextdev--hero-banners--image-content-main-timer-block-minutes'),
      seconds: timerRoot.querySelector('.nextdev--hero-banners--image-content-main-timer-block-seconds'),
    };
    if (!els.hours || !els.minutes || !els.seconds) return;

    let countdownSeconds = getSecondsUntilEndOfDay();

    const tick = () => {
      const { hours, minutes, seconds } = computeHMS(countdownSeconds);

      const h = pad2(hours), m = pad2(minutes), s = pad2(seconds);
      if (els.hours.textContent !== h)   els.hours.textContent = h;
      if (els.minutes.textContent !== m) els.minutes.textContent = m;
      animateSeconds(els.seconds, s);

      if (countdownSeconds > 0) {
        countdownSeconds--;
      } else {
        // Нулев ден - reset до края на следващия ден
        countdownSeconds = getSecondsUntilEndOfDay();
      }
    };

    tick();
    setInterval(tick, 1000);
  }

  function initAllTimers(root = document) {
    root.querySelectorAll(SELECTOR_TIMER).forEach(initTimer);
  }

  onReady(() => initAllTimers());

  document.addEventListener('shopify:section:load', (evt) => initAllTimers(evt.target));
  document.addEventListener('shopify:section:select', (evt) => initAllTimers(evt.target));
})();